import fetchInformationCard from './fetchInformationCard';

export default [fetchInformationCard];
